// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.moin-label[data-v-66ce827e] {\n  color: var(--v-primary-lighten3);\n}\n.moin-col-label[data-v-66ce827e] {\n  display: inline-block;\n  width: 100px;\n}\n.moin-col-data[data-v-66ce827e] {\n  display: inline-block;\n  width: calc(100% - 100px);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
